import React, { useCallback, useEffect, useState } from 'react';
import { Modal, ModalProps, TouchableWithoutFeedback, View } from 'react-native';
import { FadeInOut } from 'src/components/Animated';
import { GestureHandlerRoot } from './GestureHandlerRoot';
import s from './Popout.styles';

export type PopoutProps = ModalProps & {
  visible: boolean;
  /**
   * Show or hide black overlay
   */
  backdrop?: boolean;
};

export const Popout: React.FC<PopoutProps> = ({
  children,
  visible = false,
  style,
  onRequestClose,
  backdrop = true,
  onDismiss,
  ...props
}) => {
  const [show, toggle] = useState(visible);

  useEffect(() => {
    if (visible && !show) toggle(true);
  }, [visible, show]);

  const close = useCallback(() => {
    toggle(false);
    onDismiss && onDismiss();
  }, [onDismiss]);

  return (
    <Modal visible={visible || show} transparent {...props}>
      <GestureHandlerRoot style={[s.root, style]}>
        <FadeInOut style={[backdrop && s.backdrop]} visible={visible} onEnd={close}>
          <TouchableWithoutFeedback onPress={onRequestClose}>
            <View style={[s.touchable]} />
          </TouchableWithoutFeedback>
        </FadeInOut>
        {children}
      </GestureHandlerRoot>
    </Modal>
  );
};
